import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {FormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';

import {TabsModule} from '../../components/tabs/tabs.module';
import {CommonComponentsModule} from '../../common-components.module';

import {DatetimeModule} from '../../components/datetime/datetime.module';
import {ReportGeneratorComponent} from './report-generator.component';
import {ReportGeneratorListComponent} from './report-generator-list/report-generator-list.component';
import {ReportGeneratorService} from '../../services/report-generator.service';
import {ReportGeneratorModalComponent} from './report-generator-modal/report-generator-modal.component';
import {DragulaModule} from 'ng2-dragula';
import {AngularMaterialImportModule} from '../../components/angular-material-import-module/angular-material-import.module';
import {RuntimeConditionsModalComponent} from './runtime-conditions-modal/runtime-conditions-modal.component';
import {FieldsModule} from '../../components/fields/fields.module';
import {ReportGeneratorFilterComponent} from '../../components/report-generator-filter/report-generator-filter.component';
import {CustomReportViewModalComponent} from './custom-report-view-modal/custom-report-view-modal.component';
import {ReportNameModalComponent} from './report-name-modal/report-name-modal.component';
import {UtilsModule} from '../../modules/utils/utils.module';

@NgModule({
    imports: [
        BrowserModule,
        FormsModule,
        TabsModule,
        RouterModule,
        CommonComponentsModule,
        DatetimeModule,
        DragulaModule,
        AngularMaterialImportModule,
        FieldsModule,
        UtilsModule
    ],
    declarations: [
        ReportGeneratorComponent,
        ReportGeneratorListComponent,
        ReportGeneratorModalComponent,
        ReportGeneratorFilterComponent,
        RuntimeConditionsModalComponent,
        CustomReportViewModalComponent,
        ReportNameModalComponent
    ],
    providers: [
        ReportGeneratorService
    ]
})
export class ReportGeneratorModule {
}




// WEBPACK FOOTER //
// /app/src/app/views/report-generator/report-generator.module.ts